import { PropsWithChildren, ReactNode, useState } from 'react';
import { Button, H3, Card, StatusLabel, IconChevronDown, IconChevronUp } from '@snsw/react-component-library';
import styled from 'styled-components';

export interface TaskSummaryCardProps {
  title?: string | ReactNode;

  // Overrides the status text
  text?: string;

  // Overrides the status variant
  variant?: 'neutral' | 'error' | 'success' | 'warning' | 'info';

  // Has the task started?
  started?: boolean;

  // Has the task finished?
  finished?: boolean;

  collapsed?: boolean;

  // Button text
  button?: string;
  onButtonClick?: () => void;

  // Should the action button be disabled?
  disabled?: boolean;
}

const ButtonContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
`;

const SummaryCardCont = styled(Card)`
  height: auto;
`;

const TitleRow = styled.div`
  width: 100%;
  display: flex;
`;

const RowCont = styled.div`
  flex: 1;
  margin-bottom: 5px;
`;

const CollapseCont = styled.div`
  width: 100px;
  text-align: right;
  svg {
    cursor: pointer;
  }
`;

export const TaskSummaryCard = ({
  children,
  title,
  text,
  variant,
  started,
  finished,
  collapsed = false,
  disabled = false,
  onButtonClick = () => {},
  button = undefined,
}: PropsWithChildren<TaskSummaryCardProps>) => {
  const [cl, setCl] = useState(collapsed);

  const getStatus = () => {
    if (finished === true) {
      return {
        variant: 'success',
        label: 'Completed',
      };
    } else if (started === true) {
      return {
        variant: 'warning',
        label: 'Started',
      };
    } else {
      return {
        variant: undefined,
        label: 'Not started',
      };
    }
  };

  const renderButtonCopy = () => button ?? (finished === true ? 'Edit' : started === true ? 'Continue' : 'Start');

  const onCollapse = () => setCl(!cl);
  const currentStatus = getStatus();

  return (
    <SummaryCardCont
      title={
        <TitleRow>
          <RowCont>
            <StatusLabel
              text={typeof text !== 'undefined' ? text : currentStatus.label}
              variant={typeof variant !== 'undefined' ? variant : currentStatus.variant}
            />
          </RowCont>
          <CollapseCont>
            {cl ? <IconChevronDown onClick={onCollapse} /> : <IconChevronUp onClick={onCollapse} />}
          </CollapseCont>
        </TitleRow>
      }
    >
      <H3>{title}</H3>
      {!cl ? children : null}
      <ButtonContainer>
        <Button variant="secondary" onClick={onButtonClick} disabled={!!disabled}>
          {renderButtonCopy()}
        </Button>
      </ButtonContainer>
    </SummaryCardCont>
  );
};
